import { render, staticRenderFns } from "./FormHeader.vue?vue&type=template&id=2b04c36e"
import script from "./FormHeader.vue?vue&type=script&lang=ts"
export * from "./FormHeader.vue?vue&type=script&lang=ts"
import style0 from "./FormHeader.vue?vue&type=style&index=0&id=2b04c36e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports